import { DateTime } from "luxon"

import { apiClient, assertOk } from "@/api/generated/client.ts"
import type { KPI, KPIGroupRequest } from "@/types/kpiTypes.ts"

export const getKPIRequest = async (req: KPIGroupRequest): Promise<KPI[]> => {
  const convertedRequest = {
    ...req,
    asOf: req.asOf ? DateTime.fromJSDate(req.asOf).toISODate() : undefined,
  }

  const { data, error, response } = await apiClient.POST("/api/KPIs/values", {
    body: convertedRequest,
  })
  return assertOk(response, error, data)
}
